/**
 * Admin top bar: menu toggle and profile dropdown (change password, logout).
 */
import React from "react";
import PropTypes from "prop-types";

import ProfileHeaderDropdown from "./ProfileHeaderDropdown";

function Header(props) {
  const { toggleMenuCallback } = props;

  const toggleMenu = () => {
    toggleMenuCallback();
  };

  return (
    <header
      id="page-topbar"
      className="headerOrganiserStyle headerWithSidebarLayout"
    >
      <div className="navbar-header">
        <button
          type="button"
          onClick={toggleMenu}
          className="btn btn-sm font-size-16 header-item BurgerMenu"
          id="vertical-menu-btn"
        >
          <i className="fa fa-fw fa-bars" />
        </button>
        <div className="rightContainStyle ms-auto">
          <ProfileHeaderDropdown />
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  toggleMenuCallback: PropTypes.func,
  showRightSidebar: PropTypes.any,
  toggleRightSidebar: PropTypes.func,
};

export default Header;
